import { css } from "@compiled/react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import Button from "@atlaskit/button";
import { media } from "@atlaskit/primitives/responsive";

import { useLocalizedHref } from "@/libraries/web-framework";

import { Intelligence } from "./assets";

type AiSectionProps = {
    readonly title: string;
    readonly buttonText: string;
    readonly videoLink: string;
    readonly analyticsEventLabel: string;
};

const aiParentStyles = css({
    width: "100%"
});

const aiSectionStyles = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#1868DB",
    color: "white",
    height: "auto",
    padding: "64px 10%",
    gap: "32px",
    flexShrink: "0",
    width: "100%"
});

const videoStyles = css({
    maxWidth: "1187px",
    height: "auto",
    padding: "16px",
    [media.only.md]: {
        display: "none"
    },
    [media.below.md]: {
        display: "none"
    }
});

const imageStyles = css({
    width: "100%",
    height: "auto",
    padding: "16px",
    [media.above.lg]: {
        display: "none"
    }
});

const titleStyles = css({
    color: "#FFF",
    textAlign: "center",
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "48px",
    [media.only.md]: {
        fontSize: "32px"
    },
    [media.only.sm]: {
        fontSize: "32px"
    },
    [media.below.sm]: {
        fontSize: "24px"
    }
});

const buttonStyles = css({
    color: "#FFF",
    border: "1px solid #FFF !important"
});

const footerStyles = css({
    width: "100%",
    zIndex: "-1",
    marginBlockStart: "-1px"
});

export const Ai = ({
    title,
    buttonText,
    videoLink,
    analyticsEventLabel
}: AiSectionProps) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();

    const handleClick = () => {
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: `${analyticsEventLabel}`,
                section: "ai-section"
            }
        }).fire();
    };

    return (
        <div css={aiParentStyles}>
            <div css={aiSectionStyles}>
                <Intelligence />
                <div css={titleStyles}>{title}</div>
                <a
                    href={useLocalizedHref("/software/artificial-intelligence")}
                    onClick={handleClick}
                >
                    <Button appearance="primary" css={buttonStyles}>
                        {buttonText}
                    </Button>
                </a>
                <video
                    css={videoStyles}
                    playsInline={true}
                    muted={true}
                    preload="auto"
                    autoPlay={true}
                    loop={true}
                >
                    demo of jira ai integration
                    <source src={videoLink} type={`video/webm`} />
                </video>
                <img
                    css={imageStyles}
                    src="https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-img.webp                    "
                    alt="demo of AI in jira"
                />
            </div>
            <img
                css={footerStyles}
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-angle.webp"
                alt=""
            />
        </div>
    );
};
